<div class="lineItem">
  <va-icon size="small" name="search" class="icon"></va-icon>
  <nz-select
    [nzPlaceHolder]="
      selectedValue && selectedValue.label
        ? selectedValue.label
        : 'Select Line Item'
    "
    [(ngModel)]="selectedValue"
    nzShowSearch
    nzDropdownClassName="lineItem-dropdown"
    nzDropdownMatchSelectWidth="false"
    [nzSuffixIcon]="suffixIconTemplate"
    (ngModelChange)="onOptionChange($event)"
    (nzOnSearch)="lineItemSearched($event)"
    (nzOpenChange)="onOpenChange($event)"
    nzBackdrop="true"
    style="min-width: 160px; max-width: 160px"
  >
    <ng-container *ngFor="let option of options" style="min-width: 500px">
      <nz-option nzCustomContent [nzValue]="option" [nzLabel]="option['label']">
        <va-icon
          *ngIf="option['prefixIcon'] === 'check'"
          size="small"
          name="check"
          class="icon"
        ></va-icon>
        <span
          [ngClass]="{ 'selected-option': option['prefixIcon'] === 'check' }"
          [innerHTML]="highlight(option['label'])"
          class="lineItemOption"
        >
          {{ option["label"] }}
        </span>
      </nz-option>
    </ng-container>
  </nz-select>
  <ng-template #suffixIconTemplate>
    <va-icon
      *ngIf="!isOpen"
      size="small"
      name="chevron-down"
      class="icon"
    ></va-icon>
    <va-icon
      *ngIf="isOpen"
      size="small"
      name="chevron-up"
      class="icon"
    ></va-icon>
  </ng-template>
</div>
